import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Form, Input, Spin, message } from "antd";
import { useIntl } from "react-intl";
import {
  AddCateBlogAdmin,
  ShowCateBlogAdmin,
  UpdateCateBlogAdmin,
} from "../../../network/admin";
import queryClient from "../../../services/react-query/queryClient";
import { checkStringInLanguage } from "../../../utils/utils";

type Props = { close: any; id?: any };

const ModalAdminCategory = ({ close, id }: Props) => {
  const [form] = Form.useForm();
  console.log(id);

  const intl = useIntl();
  const { mutate: addCate, isLoading: isAdding } = useMutation(
    AddCateBlogAdmin,
    {
      onSuccess: (res: any) => {
        if (res?.code === "ERR_BAD_REQUEST") {
          message.error(res?.response?.data?.message);
        } else {
          console.log(res, "res");
          message.success("Category added successfully");
          queryClient.invalidateQueries(["categories"]);
          close();
        }
      },
    }
  );
  const { mutate: updateCate, isLoading: isUpdate } = useMutation(
    UpdateCateBlogAdmin,
    {
      onSuccess: (res: any) => {
        if (res?.code === "ERR_BAD_REQUEST") {
          message.error(res?.response?.data?.message);
        } else {
          console.log(res, "res");
          message.success("Category updated successfully");
          queryClient.invalidateQueries(["categories"]);
          close();
        }
      },
    }
  );
  const { data, isLoading } = useQuery(["categories", id], () =>
    ShowCateBlogAdmin(id, true)
  );
  const onFinish = (values: any) => {
    console.log("Success:", values);
    id ? updateCate({ id, ...values }) : addCate(values);
  };
  console.log(data);

  return id && isLoading ? (
    <Spin className="flex items-center justify-center" size="large" />
  ) : (
    <Form
      name="blog"
      layout={"vertical"}
      className="w-full grid-cols-1 gap-4 gap-y-0 blog-form lg:grid lg:grid-cols-2"
      initialValues={{
        name: {
          ar: data?.data?.name?.ar || "",
          en: data?.data?.name?.en || "",
        },
      }}
      onFinish={onFinish}
      form={form}
    >
      <h5 className="w-full col-span-2 mb-6 text-xl font-semibold text-center text-color-primary">
        {id ? "Edit Category" : "Add New Category"}
      </h5>
      <Form.Item
        name={["name", "ar"]}
        label={"Name" + " " + intl.formatMessage({ id: "inArabic" })}
        required={false}
        className="w-full form-style"
        rules={[
          { required: true },
          {
            type: "string",
            min: 3,
            message: intl.formatMessage({ id: "nameLt3Chr" }),
          },
          {
            validator: (_, value) => {
              if (value) {
                if (checkStringInLanguage(value, "ar")) {
                  return Promise.resolve();
                } else {
                  return Promise.reject(
                    new Error(
                      intl.formatMessage({
                        id: "service_name_arabic_error",
                      })
                    )
                  );
                }
              }
            },
          },
        ]}
      >
        <Input
          placeholder={"Name" + " " + intl.formatMessage({ id: "inArabic" })}
        />
      </Form.Item>
      <Form.Item
        name={["name", "en"]}
        label={"Name" + " " + intl.formatMessage({ id: "inEnglish" })}
        required={false}
        className="w-full form-style"
        rules={[
          { required: true },
          {
            type: "string",
            min: 3,
            message: intl.formatMessage({ id: "nameLt3Chr" }),
          },
          {
            validator: (_, value) => {
              if (value) {
                if (checkStringInLanguage(value, "en")) {
                  return Promise.resolve();
                } else {
                  return Promise.reject(
                    new Error(
                      intl.formatMessage({
                        id: "service_name_english_error",
                      })
                    )
                  );
                }
              }
            },
          },
        ]}
      >
        <Input
          placeholder={"Name" + " " + intl.formatMessage({ id: "inEnglish" })}
        />
      </Form.Item>
      <div className="flex items-center w-full col-span-2 gap-4">
        <Button
          type="primary"
          loading={isAdding || isUpdate}
          block
          htmlType="submit"
        >
          {intl.formatMessage({ id: id ? "edit" : "add" })}
        </Button>
        <Button
          type="primary"
          onClick={() => close()}
          className="w-full btn-primary-not"
          htmlType="button"
        >
          {intl.formatMessage({
            id: "cancel",
          })}
        </Button>
      </div>
    </Form>
  );
};

export default ModalAdminCategory;
